import { animate, style, transition, trigger } from '@angular/animations';

export const modalFadeAnimation = [
    trigger('fade', [
        transition(':enter', [style({ opacity: 0 }), animate(600)]),
        transition(':leave', [animate(600, style({ opacity: 1 }))]),
    ]),
];
